import { MetricCard } from './MetricCard'

interface IActiveGamesCard {
  metric: string
}

export const ActiveGamesCard = ({ metric }: IActiveGamesCard) => {
  return <MetricCard title="Active Games" metric={metric} icon="videogame-asset" />
}
